import React from 'react';

const FontTest: React.FC = () => {
  return (
    <div className="p-8 space-y-8">
      <div>
        <h2 className="text-2xl mb-2">Primary Font (Ogg)</h2>
        <h1 className="text-4xl font-ogg">This is a heading in Ogg font</h1>
        <h3 className="text-xl font-ogg mt-2">This is a subheading in Ogg font</h3>
      </div>

      <div>
        <h2 className="text-2xl mb-2">Secondary Font (Book Antiqua)</h2>
        <p className="text-lg font-body">This is body text in Book Antiqua font. It should be used for paragraphs and general content.</p>
      </div>

      <div>
        <h2 className="text-2xl mb-2">Accent Font (Editorial New)</h2>
        <blockquote className="text-xl font-accent italic border-l-4 border-gray-300 pl-4">
          This is a quote in Editorial New font. It should be used for special text elements.
        </blockquote>
      </div>

      <div className="mt-8 p-6 bg-gray-100 rounded-lg">
        <h2 className="font-ogg text-3xl mb-4">Combined Example</h2>
        <h3 className="font-ogg text-xl mb-2">Article Title</h3>
        <p className="font-body mb-4">
          This paragraph uses Book Antiqua for the main content text. The fonts should be properly loaded and displayed
          if you can see the difference between this text and the headings above.
        </p>
        <div className="font-accent text-sm">
          Caption text in Editorial New font
        </div>
      </div>
    </div>
  );
};

export default FontTest;
